import React from "react";
import "../../account/Account.css"
import Popup from 'reactjs-popup';
import Colors from "../Colors";
import ButtonLoader from "./ButtonLoader";
import Aux from "../AuxFunctions";
class CongratulationsModal extends React.Component {

    render() {
        return (
            <Popup 
                contentStyle={{width: "auto", borderRadius:10}}
                open={this.props.active} 
                onClose={this.props.onClose}
                closeOnDocumentClick
                modal
                >
                    {close => (
                    <div style={{display:"flex", maxWidth: 400, flexDirection:"column", padding:40, alignItems:"center" }}>
                        <h2>{this.props.title || "Congratulations!"} </h2>
                        <img style={{ height: 100, width: 100, objectFit:"contain", margin:"10px 0px" }}
                                src={Aux.GiftBox} alt="avatar">
                        </img>
                            {/* <div></div> */}
                    <h5 style={{marginTop:10, color:Colors.softText}}>{this.props.text || "You've just won"} </h5>
                    <h1 style={{marginBottom:10 }}>{this.props.coins}$!</h1>
                        {/* <h3>{this.props.coins}$</h3> */}
                        <ButtonLoader
                            text="Close"
                            style={{backgroundColor: Colors.red, width:150, padding:"12px 20px"}}
                                // icon={FacebookIcon}
                            onClick={close}
                        />

                    </div>)}
            </Popup>
        );
    }
}

export default CongratulationsModal